<template>
  <div class="">
    <vs-row>
      <vs-col vs-type="flex" vs-w="12" vs-align="flex-end" vs-justify="flex-end">
        <div class="demo-alignment">
          <vs-button class="okBtn" color="success" @click="gotoDashboard">Ok</vs-button>
        </div>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-offset="3" v-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
        <div class="agreement-body receipt" >
          <img src="@/assets/images/pages/receiptUser.jpg" alt="">

          <br>
          <h4>ACKNOWLEDGEMENT OF HIRER</h4>
          <p>I <span class="sp-val"><strong>{{userEkyc.parsonal.name}} {{userEkyc.parsonal.last_name}}</strong></span> hereby acknowledged that I have been shown this
            mandatory receipt of the company, a sample of which is printed above and I understand that I must receive a
            receipt(electronic/printed)for every payment made. I further understand that the company will not acknowledge
            any other receipt except their mandatory receipt and if I make a payment without a receipt, or accept any
            other receipt,I do so entirely atmy risk and responsibilities</p>
          <h4>ভাড়াগ্রহিতার স্বীকারোক্তি</h4>
          <p>আমি <span class="sp-val"><strong>{{userEkyc.parsonal.name}} {{userEkyc.parsonal.last_name}}</strong></span> এইমর্মে ঘোষণা করিতেছি যে, আমি কোম্পানীর অত্র বাধ্যতামূলক রশিদ দেখেছি যার
            একটি নমূনা কপি উপরে মূদ্রিত এবং আমি অবগত হলাম যে, আমি প্রত্যেক পেমেন্টের বিপরীতে অনুরুপ একটি বাধ্যতামূলক
            রশিদ (ইলেক্ট্রনিক/মূদ্রিত আকারে) অবশ্যই গ্রহণ করিব। আমি আরও অবগত হলাম যে, কোম্পানী তাহার বাধ্যতামূলক রশিদ
            ব্যতিত অন্য কোন রশিদ গ্রহণ করিবেন না, এবং আমি যদি রশিদ ব্যতিত কোন টাকা প্রদান করি বা অন্য কোন রশিদ গ্রহণ করি
            তাহলে তাহা আমার নিজ দায়িত্বে করেছি বলে বিবেচিত হইবে এবং আমি সম্পুর্ণরুপে তাঁর দায়-দায়িত্ব বহন করিব।</p>
          <br>
          <br>
          <br>
          <p>
            This Agreement made this <span class="sp-val"><strong>{{day}}</strong></span> Day of <span class="sp-val"><strong>{{month=='01'?'January': month=='02'?'February': month=='03'?'March':month=='04'?'April':month=='05'?'May':month=='06'?'Jun':month=='07'?'July':month=='08'?'August':month=='09'?'September':month=='10'?'October':month=='11'?'November':month=='12'? 'December':''}}</strong></span><strong>{{year}}</strong> between Butterfly Marketing Limited a company registered in
            Bangladesh and having its office at 71, Motijheel C/A, Dhaka – 1000.(Herein after called the owner) of the
            First part.
            <br>
            And Mr/Mrs <span class="sp-val"><strong>{{userEkyc.parsonal.name}} {{userEkyc.parsonal.last_name}}</strong></span>
             S/O. W/O <span class="sp-val"><strong>

            <span v-if="userEkyc.parsonal.gender==='Female'"><span v-if="userEkyc.parsonal.marital_status==='Married'">{{userEkyc.parsonal.spouse_name}}</span> <span v-if="userEkyc.parsonal.marital_status !== 'Married'">{{userEkyc.parsonal.father_name}}</span></span>
            <span v-if="userEkyc.parsonal.gender!=='Female'"> {{userEkyc.parsonal.father_name}}</span>

          </strong></span>
             NID <strong> <span class="sp-val">{{userEkyc.parsonal.nid}}</span></strong>
            Present address <span class="sp-val"><strong>{{userEkyc.contact.presentAddress.address}}, {{userEkyc.contact.presentAddress.thana}}, {{userEkyc.contact.presentAddress.district}}, {{userEkyc.contact.presentAddress.division}} - {{userEkyc.contact.presentAddress.postal_code}} </strong></span>.
            and Permanent address <span class="sp-val"><strong>{{userEkyc.contact.permanentAddress.paddress}}, {{userEkyc.contact.permanentAddress.pthana}}, {{userEkyc.contact.permanentAddress.pdistrict}}, {{userEkyc.contact.permanentAddress.pdivision}} - {{userEkyc.contact.permanentAddress.ppostal_code}} </strong></span>.
            (Herein after called “the Hirer”) of Second part.

            And (i) Mr/Mrs <span class="sp-val"><strong>{{guarantorOne.ekyc.parsonal.name}} {{guarantorOne.ekyc.parsonal.last_name}}</strong></span>
            NID No. <span class="sp-val">{{guarantorOne.ekyc.parsonal.nid}}</span>

            Present address <span class="sp-val"><strong>{{guarantorOne.ekyc.contact.presentAddress.address}}, {{guarantorOne.ekyc.contact.presentAddress.thana}}, {{guarantorOne.ekyc.contact.presentAddress.district}}, {{guarantorOne.ekyc.contact.presentAddress.division}} - {{guarantorOne.ekyc.contact.presentAddress.postal_code}}</strong></span>.
            and Permanent address <span class="sp-val"><strong>{{guarantorOne.ekyc.contact.permanentAddress.paddress}}, {{guarantorOne.ekyc.contact.permanentAddress.pthana}}, {{guarantorOne.ekyc.contact.permanentAddress.pdistrict}}, {{guarantorOne.ekyc.contact.permanentAddress.pdivision}} - {{guarantorOne.ekyc.contact.permanentAddress.ppostal_code}}</strong></span>.

            (ii) Mr/Mrs <span class="sp-val"><strong>{{guarantorTwo.ekyc.parsonal.name}} {{guarantorTwo.ekyc.parsonal.last_name}} </strong> </span> No. <span class="sp-val"><strong>{{guarantorTwo.ekyc.parsonal.nid}}</strong></span>.
            Present address <span class="sp-val"><strong>{{guarantorTwo.ekyc.contact.presentAddress.address}}, {{guarantorTwo.ekyc.contact.presentAddress.thana}}, {{guarantorTwo.ekyc.contact.presentAddress.district}}, {{guarantorTwo.ekyc.contact.presentAddress.division}} - {{guarantorTwo.ekyc.contact.presentAddress.postal_code}}</strong></span>.
            And Permanent address<span class="sp-val"> <strong>{{guarantorTwo.ekyc.contact.permanentAddress.paddress}}, {{guarantorTwo.ekyc.contact.permanentAddress.pthana}}, {{guarantorTwo.ekyc.contact.permanentAddress.pdistrict}}, {{guarantorTwo.ekyc.contact.permanentAddress.pdivision}} - {{guarantorTwo.ekyc.contact.permanentAddress.ppostal_code}}</strong></span>.
            Of the Third part, (herein after jointly called the guarantor).

          </p>
          <p>
            অত্র চুক্তিনামা অদ্য <span class="sp-val"><strong>{{day}}</strong></span> মাস<span class="sp-val"><strong>{{month=='01'?'January': month=='02'?'February': month=='03'?'March':month=='04'?'April':month=='05'?'May':month=='06'?'Jun':month=='07'?'July':month=='08'?'August':month=='09'?'September':month=='10'?'October':month=='11'?'November':month=='12'? 'December':''}}</strong></span> <strong>{{year}}</strong> ইং তারিখে বাটারফ্লাই মার্কেটিং লিমিটেড, বাংলাদেশের
            একটি নিবন্ধিত কোম্পানী যাহার নিবন্ধিত ঠিকানাঃ ৭১ মতিঝিল, বা/এ, ঢাকা-১০০০। (অতপর যাহাকে “মালিক” হিসেবে অবহিত
            করা হইবে) প্রথম পক্ষ। এবং জনাব/জনাবা <span class="sp-val"><strong>{{userEkyc.parsonal.name}} {{userEkyc.parsonal.last_name}}</strong></span>  আই.ডি নংঃ
            <span class="sp-val"><strong>{{userEkyc.parsonal.nid}}</strong></span> বর্তমান ঠিকানাঃ <span class="sp-val"><strong>{{userEkyc.contact.presentAddress.address}}, {{userEkyc.contact.presentAddress.thana}}, {{userEkyc.contact.presentAddress.district}}, {{userEkyc.contact.presentAddress.division}} - {{userEkyc.contact.presentAddress.postal_code}} </strong></span>.
             এবং স্থায়ী ঠিকানাঃ <span class="sp-val"><strong>{{userEkyc.contact.permanentAddress.paddress}}, {{userEkyc.contact.permanentAddress.pthana}}, {{userEkyc.contact.permanentAddress.pdistrict}}, {{userEkyc.contact.permanentAddress.pdivision}} - {{userEkyc.contact.permanentAddress.ppostal_code}}</strong></span>
             (অতপর যাহাকে ভাড়াগ্রহিতা হিসেবে অবহিত করা হইবে) দ্বিতীয় পক্ষ। এবং জনাব/জনাবা <span class="sp-val"><strong>{{guarantorOne.ekyc.parsonal.name}} {{guarantorOne.ekyc.parsonal.last_name}}</strong></span> আই.ডি নংঃ
            <span class="sp-val"><strong>{{guarantorOne.ekyc.parsonal.nid}}</strong></span> বর্তমান ঠিকানা: <span class="sp-val"><strong>{{guarantorOne.ekyc.contact.presentAddress.address}}, {{guarantorOne.ekyc.contact.presentAddress.thana}}, {{guarantorOne.ekyc.contact.presentAddress.district}}, {{guarantorOne.ekyc.contact.presentAddress.division}} - {{guarantorOne.ekyc.contact.presentAddress.postal_code}}</strong></span>. এবং স্থায়ী ঠিকানা:
            <span class="sp-val"><strong>{{guarantorOne.ekyc.contact.permanentAddress.paddress}}, {{guarantorOne.ekyc.contact.permanentAddress.pthana}}, {{guarantorOne.ekyc.contact.permanentAddress.pdistrict}}, {{guarantorOne.ekyc.contact.permanentAddress.pdivision}} - {{guarantorOne.ekyc.contact.permanentAddress.ppostal_code}}</strong></span>.
            । জনাব/জনাবা <span class="sp-val"><strong>{{guarantorTwo.ekyc.parsonal.name}} {{guarantorTwo.ekyc.parsonal.last_name}}</strong> </span>আই.ডি নংঃ <span class="sp-val"><strong>{{guarantorTwo.ekyc.parsonal.nid}}</strong> </span>বর্তমান
            ঠিকানা: <span class="sp-val"><strong>{{guarantorTwo.ekyc.contact.presentAddress.address}}, {{guarantorTwo.ekyc.contact.presentAddress.thana}}, {{guarantorTwo.ekyc.contact.presentAddress.district}}, {{guarantorTwo.ekyc.contact.presentAddress.division}} - {{guarantorTwo.ekyc.contact.presentAddress.postal_code}}</strong></span> এবং স্থায়ী ঠিকানা:
            <span class="sp-val"><strong>{{guarantorTwo.ekyc.contact.permanentAddress.paddress}}, {{guarantorTwo.ekyc.contact.permanentAddress.pthana}}, {{guarantorTwo.ekyc.contact.permanentAddress.pdistrict}}, {{guarantorTwo.ekyc.contact.permanentAddress.pdivision}} - {{guarantorTwo.ekyc.contact.permanentAddress.ppostal_code}}</strong></span>
            (অতপর যাহাদিগকে যৌথভাবে “জামিনদার” হিসেবে অবহিত করা হইবে) তৃতীয় পক্ষ।
          </p>
          <br>
          <p><strong>Witnessed as follows: শর্তসমূহ নিম্নরূপঃ</strong></p>
          <div class="parent_dv">
            <ul>
              <li>1.</li>
              <li>In Consideration of an initial payment of TK<span class="sp-val"><strong>{{productMaster.down_payment}}</strong></span>made this day and the future
                rentals
                to be paid by the hirer, the owner at the request of the guarantorshereby agrees to let on hirer (with
                an
                option to purchase) Model <span class="sp-val"><strong>( Article No - {{productMaster.article}} )  {{productMaster.article_description}}</strong></span> SerialNo. <span class="sp-val"><strong>{{purchase.serial_number}} </strong></span> and the accessories
                (herein
                after called “The Property”) worth Hire Tk. <span class="sp-val"><strong>{{productMaster.hire_price}}</strong></span> Taka (in words)
                <span class="sp-val"><strong>{{convertToWord(productMaster.hire_price)}}</strong></span> and service
                charge TK <span class="sp-val"><strong>{{ Math.floor(parseInt(productMaster.hire_price)*0.1) }}</strong></span> Taka(in word) <span class="sp-val"><strong>{{convertToWord(Math.floor(parseInt(productMaster.hire_price)*0.1))}}</strong></span>
                Total TK. <span class="sp-val"><strong>{{ Math.floor(parseInt(productMaster.hire_price))+Math.floor(parseInt(productMaster.hire_price)*0.1)}} </strong></span>Taka(in word) <span class="sp-val"><strong>{{convertToWord(Math.floor(parseInt(productMaster.hire_price))+Math.floor(parseInt(productMaster.hire_price)*0.1))}}</strong></span>
              </li>
            </ul>
            <ul>
              <li>১.</li>
              <li>অদ্য ভাড়াগ্রহিতা কর্তৃক প্রাথমিক কিস্তি হিসেবে <span class="sp-val"><strong>{{productMaster.down_payment}}</strong></span> টাকা পরিশোধ করিলে এবং পরবর্তী ভাড়া
                সমূহ সময়মত পরিশোধ করা হবে মর্মে রাজি হলে, জামানতদারের অনুরোধে কোম্পানী পণ্যটি ( পরবর্তীতে ক্রয়ের সুযোগ
                সহকারে) ভাড়া প্রদান করিতে সম্মত হলেন আনুষাঙ্গিক যন্ত্রপাতি সহকারে যাহার মডেলঃ <span class="sp-val"><strong> ( Article No - {{productMaster.article}} ) {{productMaster.article_description}}</strong></span> সিরিয়াল
                নংঃ <span class="sp-val"><strong>{{purchase.serial_number}}</strong></span> (অতপর যাহাকে “সম্পত্তি” হিসেবে অবহিত করা হইবে) যাহার ভাড়া
                মূল্যঃ<span class="sp-val"><strong>{{productMaster.hire_price}}</strong></span> টাকা (কথায়) <span class="sp-val"><strong>{{convertToWord(productMaster.hire_price)}}</strong></span> এবং
                সার্ভিস চার্জঃ <span class="sp-val"><strong>{{ Math.floor(parseInt(productMaster.hire_price)*0.1) }}</strong></span> টাকা (কথায়) <span class="sp-val"><strong>{{convertToWord(Math.floor(parseInt(productMaster.hire_price)*0.1))}}</strong></span>,
                মোট. <span class="sp-val"><strong>{{ Math.floor(parseInt(productMaster.hire_price))+Math.floor(parseInt(productMaster.hire_price)*0.1)}}</strong></span> টাকা (কথায়).<span class="sp-val"><strong>{{convertToWord(Math.floor(parseInt(productMaster.hire_price))+Math.floor(parseInt(productMaster.hire_price)*0.1))}}</strong></span> ।
              </li>
            </ul>
          </div>
          <p><span>2.</span> The hirer agrees so long as the hiring shall continue:</p>
          <p><span>২.</span> ভাড়াগ্রহিতা ভাড়া চলমান থাকাকালীন এইমর্মে সম্মত হলেন যেঃ </p>
          <div class="child_dv">
            <ul>
              <li>a.</li>
              <li>To pay to the owner at its office at 71, Motijheel C/A, Dhaka-1000 or at (branch address) or at such
                other address as may from time to time be notified, a monthly rental of Tk.<span class="sp-val"><strong>{{productMaster.monthly_inst}}</strong></span>
                payable regularly on or before the 7th day of each month, No payments to the owner shall be recognized unless the hirer as received in exchange for such payment an official electronic/printed receipt or receipts issued by the owner and signed by the owner’s authorized representative.
              </li>
            </ul>
            <ul>
              <li>ক.</li>
              <li>তিনি (ভাড়াগ্রহিতা) ভাড়াকৃত সম্পত্তির মাসিক ভাড়া <span class="sp-val"><strong>{{productMaster.monthly_inst}}</strong></span> টাকা প্রতি মাসের ৭ তারিখের মধ্যে মালিকের অফিসের ঠিকানা ৭১, মতিঝিল, ঢাকা-১০০০ অথবা শাখার ঠিকানা অথবা মালিককর্তৃক সময়ে সময়ে পরিবর্তিত ও ঘোষিত অন্য নতুন  ঠিকানায় পরিশোধ করিবেন। মালিক বা তাহার ক্ষমতাপ্রাপ্ত প্রতিনিধি কর্তৃক ইস্যুকৃত (ইলেক্ট্রনিক/প্রিন্টেড) অফিসিয়াল রশিদ ব্যতিত ভাড়াটিয়া কর্তৃক টাকা পরিশোধ করার কোন দাবী গ্রহণযোগ্য হইবেনা।
              </li>
            </ul>
            <ul>
              <li>b.</li>
              <li>To keep the property in good and working condition and at all reasonable times to allow the owner
                and/or
                its representative to inspect the same.
              </li>
            </ul>
            <ul>
              <li>খ.</li>
              <li>তিনি (ভাড়াগ্রহিতা) ভাড়াকৃত সম্পত্তিটি যথাযথ মেরামত এবং কর্ম উপযোগী করে রাখিবে এবং যেকোন যৌক্তিক সময়ে
                মালিক বা তাহার প্রতিনিধিকে উহা পরির্দশন করার সুযোগ প্রদান করিবেন।
              </li>
            </ul>
            <ul>
              <li>c.</li>
              <li>Not to employ any but the owner’s workman to effect repairs to the property. The hirer shall be
                responsible to the owner for any damage arising from repairs to the said property being entrusted to
                workmen other than the owner’s authorized workman.
              </li>
            </ul>
            <ul>
              <li>গ.</li>
              <li>তিনি (ভাড়াগ্রহিতা) ভাড়াকৃত সম্পত্তিটি মেরামতের ক্ষেত্রে মালিক পক্ষের লোকজন ব্যতিত অন্য কাউকে নিযুক্ত
                করতে পারিবেন না। মালিকের ক্ষমতাপ্রাপ্ত কর্মচারী/টেকনিশিয়ান ব্যতীত মেরামত কাজ করার সময় সম্পত্তিটির কোন
                প্রকার ক্ষয়ক্ষতি হইলে তাহার জন্য ভাড়াগ্রহিতা মালিকের নিকট দায়বদ্ধ থাকিবেন ।
              </li>
            </ul>
            <ul>
              <li>d.</li>
              <li>To keep the property and accessories in the Hirer's own custody at the abovementioned address and not
                to remove them there from without the owner's previous consent in writing and not to sell or pawn or
                rent
                or to dispose of or to deal with them in any way whatsoever. A breach of this conversant by the Hirer
                with
                or without the knowledge of the guarantors or either of them shall entitle the owner to terminate this
                agreement forthwith.
              </li>
            </ul>
            <ul>
              <li>ঘ.</li>
              <li>তিনি (ভাড়াগ্রহিতা) ভাড়াকৃত সম্পত্তি এবং আনুষাঙ্গিক মালামাল উপরোল্লিখিত ঠিকানায় নিজ জিম্মায় যথাস্থানে
                রাখিবেন এবং মালিকের লিখিত অনুমতি ব্যতিত তাহা সরাতে পারবেন না এবং তাহা বিক্রয় বা বন্ধক বা হস্তান্তর অথবা
                অন্যকোনভাবে কোন লেনদেন করতে পারিবেন না। যদি ভাড়াগ্রহিতা জামিনদারের জ্ঞাত বা অজ্ঞাতসারে এই ভাড়া চুক্তির
                কোন
                ব্যতিক্রম করেন তাহলে মালিক অত্র চুক্তিনামা বাতিল করিতে পারিবেন।
              </li>
            </ul>
            <ul>
              <li>e.</li>
              <li>Without prejudice to the provisions of sub clause (d) above, it is understood that in no event will
                the owner consent to the property and accessories being removed from the above mentioned address if they
                are to be taken to a town or village within the municipal limits or which the owner does not have its
                own
                shop or branch office and the hirer hereby expressly agrees that if he/she is about to move from the
                above
                mentioned address to such a town or village, as aforesaid, he/she will have to close the account by
                paying
                all the amount before moving.
              </li>
            </ul>
            <ul>
              <li>ঙ.</li>
              <li>উল্লেখিত উপ ধারা (ঘ) এ বর্ণিত বিধানের পক্ষপাত ব্যতিত, এ কথা বুঝা গেল যে, ভাড়াকৃত সম্পত্তি নির্দিষ্ট
                ঠিকানা হতে মালিকের অনুমতি ব্যতিত কোন অবস্থাতে হস্তান্তর করা যাইবে না। যদি তিনি (ভাড়াগ্রহিতা) উল্লেখিত
                ঠিকানা ব্যতিত অন্য কোন শহর বা গ্রামে চলে যান যেখানে মালিকের নিজস্ব কোন দোকান বা শাখা নাই সেক্ষেত্রে তিনি
                চলে যাওয়ার পূর্বে তাহার সমস্ত বকেয়া পরিশোধ করে তাহার হিসাব বন্ধ করে ফেলিবেন।
              </li>
            </ul>
            <ul>
              <li>f.</li>
              <li>To pay to the owner on demand all expenses, costs or charges incurred in ascertaining the whereabout
                of
                the hirer or the property or in recovering endeavor to recover possession thereof from any one in whose
                possession the property is kept for the time being.
              </li>
            </ul>
            <ul>
              <li>চ.</li>
              <li>মালিক পক্ষ দাবী করার সাথে সাথে ভাড়াকৃত সম্পত্তিটি বা ভাড়াটিয়া কে খুঁজে বের করতে বা সম্পত্তিটি
                ভাড়াগ্রহিতা বা অন্য কারও দখল থেকে দখল উদ্ধার করতে যে সকল খরচপাতি, ব্যয় বা চার্জ সমূহ হবে তা পরিশোধ
                করিবেন।
              </li>
            </ul>
          </div>
          <div class="parent_dv">
            <ul>
              <li>3.</li>
              <li>The hirer shall be liable to pay damages to the owner, whether his/her is negligent or not, if the
                property is damaged or destroyed either by fire, floods or otherwise howsoever or lost or stolen or has
                otherwise gone out possession or control of the hirer. Such damages shall be calculated on the basis of
                the value of the property being the original worth less the amount of the initial payment and the
                rentals
                paid under this agreement.
              </li>
            </ul>
            <ul>
              <li>৩.</li>
              <li>ভাড়াগ্রহিতা, তার উদাসীনতা থাকুক বা না থাকুক, যদি সম্পত্তিটি আগুন, বন্যা বা অন্য কোন উপায়ে ক্ষতি বা
                ধ্বংস
                হয় বা হারিয়ে যায় বা চুরি হয়ে যায় বা যে কোন উপায়ে তাঁর বেদখল হয়ে যায় সেক্ষেত্রে মালিককে ক্ষতিপূরণ প্রদান
                করিতে দায়বদ্ধ থাকিবেন। উক্ত ক্ষয়ক্ষতির পরিমান নির্ধারণের ক্ষেত্রে সম্পত্তিটির আসল মূল্যমানের থেকে
                ইনিশিয়াল
                পেমেন্ট এবং অত্র চুক্তিনামার অধীনে প্রদানকৃত ভাড়া বাদ দেওয়া হইবে।
              </li>
            </ul>
            <ul>
              <li>4.</li>
              <li>The property being that of the owner, shall not be subject to any lien charges or claim in respect of
                any rent due by the hirer to his/her landlord, lessor or owner of any premises where he/she may be
                residing or carrying on business or where the said property may be kept at any time.
              </li>
            </ul>
            <ul>
              <li>৪.</li>
              <li>সম্পত্তি মালিকেরই থাকিবে, ইহাতে কোন প্রকার লিয়েন চার্জ করা যাইবেনা অথবা যেখানে তিনি [ভাড়াগ্রহিতা]
                বসবাস করছেন বা ব্যবসা পরিচালনা করছেন বা ভাড়াকৃত সম্পত্তিটি রেখেছেন উহার মালিক বা ইজারাদাতার প্রাপ্য
                বাড়ার
                বিষয়বস্তু হিসেবে গণ্য হইবেনা।
              </li>
            </ul>
            <ul>
              <li>5.</li>
              <li>The hirer may at any time terminate the hiring by returning the property at his/her own cost to the
                owner at its registered office in Dhaka or concerned showroom but such termination of the hiring, shall
                not relieve the hirer of his/her obligation to pay any sums due from him/her under this agreement or
                prejudice any claim of the owner or entitle the hirer to the return of any money already paid by.
              </li>
            </ul>
            <ul>
              <li>৫.</li>
              <li>ভাড়াগ্রহিতা যে কোন সময় ভাড়াকৃত সম্পত্তিটি তাহার নিজ খরচে মালিকের ঢাকাস্থ নিবন্ধিত ঠিকানায় বা সংশিষ্ট
                শোরুমে পৌছাইয়া দিয়া চুক্তিটি অবসান করিতে পারিবেন। কিন্তু এরুপ অব্যাহতি ভাড়াগ্রহিতাকে অত্র চুক্তি অনুযায়ী
                মালিকের প্রাপ্য অর্থ প্রদানের বাধ্যবাধকতা থেকে মুক্তি দিবে না বা ভাড়াটিয়া কর্তৃক পরিশোধকৃত কোন টাকা
                মালিক
                হইতে ফেরত নেয়ার অধিকারী হইবে না।
              </li>
            </ul>

            <ul>
              <li>6.</li>
              <li>The hirer, provided he/she strictly performs the terms and conditions of this agreement and is not in
                default under any of its provisions shall at any time during the continuance of this agreement be
                entitled
                the exercise his option to purchase the property by paying the difference between the sum already paid
                by
                way of initial payment and hiring rentals and the amount stated in clause 1 above less the amount as
                specified in the discount chart provided by the owner.
              </li>
            </ul>
            <ul>
              <li>৬.</li>
              <li>ভাড়াগ্রহিতা, অত্র চুক্তিনামার সকল শর্ত মেনে এবং এর কোন শর্ত ভঙ্গ না করে, শর্তসাপেক্ষে সম্পত্তিটি
                তাহার উপরোল্লিখিত ১ নং অনুচ্ছেদ অনুযায়ী বর্র্ণিত প্রাথমিক প্রদত্ত অর্থ ও পরিশোধিত সকল কিস্তি এবং মালিক
                কর্তৃক প্রদত্ত ডিসকাউন্ট বাদ দিয়ে যে মূল্য হবে তা পরিশোধ করে ক্রয়ের সুবিধা ভোগ করিতে পারিবেন।
              </li>
            </ul>
          </div>
          <p>7. If during the hiring the hirer shall: -</p>
          <p>৭. যদি ভাড়া চলাকালীন সময়ে ভাড়াগ্রহিতাঃ -</p>
          <div class="child_dv">
            <ul>
              <li>i.</li>
              <li>Make default in payment of a sum payable hereunder.</li>
            </ul>
            <ul>
              <li>ক.</li>
              <li>প্রদেয় কোন অর্থ প্রদানে ব্যর্থ হয়।</li>
            </ul>
            <ul>
              <li>ii.</li>
              <li> Die or be adjudicated, insolvent or compound with his creditors or being a company go into
                inquisition
                or receiver appointed.
              </li>
            </ul>
            <ul>
              <li>খ.</li>
              <li> মৃত্যুবরণ করিলে বা সাজাপ্রাপ্ত হইলে বা দেউলিয়া অথবা ঋণগ্রস্থ হইলে বা কোম্পানীরক্ষেত্রে আদালত কর্তৃক
                অবসান হইলে বা রিসিভার নিযুক্ত হইলে।
              </li>
            </ul>
            <ul>
              <li>iii.</li>
              <li>Have execution or sequestration levied against him/her or allows the property to be seized under any
                distress execution or any other process or to be detained by reason of any alleged lien.
              </li>
            </ul>
            <ul>
              <li>গ.</li>
              <li>তাহার বিরুদ্ধে কোন দন্ড আরোপিত হইলে বা কোন অনাকাংক্ষিত কারনে সম্পত্তি বাজেয়াপ্ত ঘোষণা করা হইলে বা কোন
                লিয়েনের কারণে সম্পত্তিটি জব্দ হইলে।
              </li>
            </ul>
            <ul>
              <li>iv.</li>
              <li> Do any act, which may prejudice the owner’s rights to the property.</li>
            </ul>
            <ul>
              <li>ঘ.</li>
              <li> মালিকের অধিকার খর্ব হয় এমন কোন কাজ করিলে।</li>
            </ul>
            <ul>
              <li>v.</li>
              <li>Fail to duly observe and perform all or any of the terms, conditions and stipulations on his part
                herein
                contained (time being of the essence of the contract),
              </li>
            </ul>
            <ul>
              <li>ঙ.</li>
              <li>অত্র চুক্তিপত্রে উল্লেখিত কোন শর্তসমূহ যথাযথ ভাবে পালনে ব্যর্থ হয় [সময়সীমা অত্র চুক্তির অন্ত:সার]</li>
            </ul>

            <ul>
              <li></li>
              <li>Then the owner shall be entitled (without prejudice any other rights hereunder) forthwith to terminate
                the hiring and retake possession of the property under this agreement.
              </li>
            </ul>
            <ul>
              <li></li>
              <li>তাহলে মালিক [তাহার অন্যান্য অধিকার খর্ব না করে] এই ভাড়াচুক্তির অবসান করিতে এবং চুক্তিভুক্ত ভাড়া
                সম্পত্তির দখল নিতে পারিবেন।
              </li>
            </ul>
          </div>
          <div class="parent_dv">
            <ul>
              <li>8.</li>
              <li> On the hiring being terminated under the first preceding clause the hirer shall forthwith
                deliver the
                said property to the owner at its registered place of business free of any charge and on his/her failure
                to do so, the owner or it’s agent or any other person duly authorized by the owner shall be entitled to
                enter upon any premises where the property may be or is believed to be kept and take possession of the
                same without being liable to any suit or other proceedings by the hirer or any person claiming under
                him/her or otherwise.
              </li>
            </ul>

            <ul>
              <li>৮.</li>
              <li> পূর্ববর্তী ধারা অনুসারে ভাড়া চুক্তিটি পরিসমাপ্তি হইলে, ভাড়াগ্িরহতা তৎক্ষনাৎ উক্ত
                সম্পত্তিটি
                মালিকের
                নিকট তাঁর নিবন্ধিত ব্যবসায়ের স্থানে বিনা খরচে ফেরত প্রদান করিবেন এবং এটি করতে তার ব্যর্থতার কারনে মালিক
                বা
                তাহার এজেন্ট বা মালিক কর্তৃক যথাযথ অনুমোদিত অন্য কোন ব্যক্তি যে কোন জায়গায় যেখানে সম্পত্তিটি রাখা আছে
                অথবা
                আছে বলে বিশ^াস করা হয় সেখানে প্রবেশ করে, ভাড়াগ্রাহিতা বা অন্য কোন ব্যক্তি কর্তৃক যেকোন প্রকার মামলা বা
                প্রসিডিং এর দায়বদ্ধতা ছাড়া সম্পত্তিটির দখল নিতে পারিবেন।
              </li>
            </ul>

            <ul>
              <li>9.</li>
              <li>Upon termination of the hiring under any of the provisions of this agreement the hirer
                shall
                pay
                forthwith to the owner all hiring rentals in arrears or due to the date of receipt of the property by
                the
                owner all cost or charges payable under any of the provisions of this agreement including cost of taking
                possession and removal of the property and all costs incidental to putting the property in a proper
                state
                and good condition by repair. In no event will any sum already paid under the provisions of this
                agreement
                be refundable by the owner to the hirer.
              </li>
            </ul>
            <ul>
              <li>৯.</li>
              <li>অত্র চুক্তিপত্রের কোন বিধান অনুযায়ী চুক্তিটি অবসানের ক্ষেত্রে ভাড়াগ্রহিতা মালিককে
                সম্পত্তিটি
                ভাড়া
                গ্রহণের দিন থেকে প্রাপ্য সকল ভাড়া ও পাওনা এবং এই চুক্তি অনুযায়ী সম্পত্তিটি দখল গ্রহণ, অপসারণ এবং মেরামত
                সহ
                সকল ধরনের খরচ ও চার্জ প্রদান করিবেন। কোন অবস্থাতইে এই চুক্তরি অধীনে প্রদত্ত যে কোন পরমিাণ অর্থ মালকি
                র্কতৃক ভাড়াগ্রহিতাকে ফরেতযোগ্য হইবে না।
              </li>
            </ul>
            <ul>
              <li>10.</li>
              <li>This agreement is personal to the Hirer; and the rights and/or obligations of the Hirer
                shall not be assignable or changeable by him/her directly or indirectly.
              </li>
            </ul>

            <ul>
              <li>১০.</li>
              <li> অত্র চুক্তিপত্রটি ভাড়াগ্রহিতার ব্যক্তিগত, এবং ভাড়াগ্রহিতার অধিকার এবং/বা বাধ্যবাধকতা
                ধু¡ষ
                দ্বারা প্রত্যক্ষ বা পরোক্ষভাবে অর্পণযোগ্য বা পরিবর্তনযোগ্য হইবে না।
              </li>
            </ul>
            <ul>
              <li>11. </li>
              <li>The guarantor do jointly and severally agree and undertake that their obligations shall be
                concurrent with the hirer’s, as through in all respects each of them was himself/herself the hirer and
                jointly and severally guarantee to the owner:
              </li>
            </ul>
            <ul>
              <li>১১.</li>
              <li>
                নিশ্চয়তা প্রদানকারীগণ যৌথ ও এককভাবে সম্মত ও অঙ্গিকার প্রদান করছেন যে, তাদের দায়দায়িত্ব ভাড়াগ্রহিতার মত
                একই
                রকম হইবে। সার্বিকভাবে তারা প্রত্যেকে নিজেই ভাড়া গ্রহিতা এবং যৌথ ও এককভাবে মালিককে নিশ্চয়তা প্রদান
                করিতেছে।
              </li>
            </ul>
          </div>
          <div class="child_dv">
            <ul>
              <li>a.</li>
              <li> Regular and punctual payment of all monthly hiring rentals hereby provided and</li>
            </ul>
            <ul>
              <li>ক.</li>
              <li> নিয়মিত এবং সময়োপযোগীভাবে উল্লেখিত মাসিকভাড়া প্রদান করিবেন এবং</li>
            </ul>
            <ul>
              <li>b.</li>
              <li> Payment to the owner of all money becoming payable to it under or by virtue of this agreement either
                by
                way of debt or hire or costs or expenses or otherwise howsoever.
              </li>
            </ul>
            <ul>
              <li>খ.</li>
              <li>অত্র চুক্তির অধীনে ঋণ বা কিস্তি বা খরচ সহ মালিককে প্রদেয় অন্য কোন পাওনা পরিশোধ করিবেন।</li>
            </ul>
          </div>
          <div class="parent_dv">
            <ul>
              <li>12.</li>
              <li>The guarantors further agree:</li>
            </ul>
            <ul>
              <li>১২.</li>
              <li>নিশ্চয়তা প্রদানকারীগণ আরও সম্মত হলেন যেঃ</li>
            </ul>
          </div>
          <div class="child_dv">
            <ul>
              <li>a.</li>
              <li> That the owner shall be at liberty to sue the hirer and the guarantors jointly and/or severally and
                the guarantors further agree that the owner shall be entitled to proceed against the guarantors only in
                the first instance, either jointly and/or severally.
              </li>
            </ul>
            <ul>
              <li>ক.</li>
              <li>মালিক, ভাড়াগ্রহিতা এবং জামিনদারদের বিরুদ্ধে একক অথবা যৌথভাবে মামলা কারার ক্ষেত্রে স্বাধীনতা ভোগ করিবেন
                এবং জামিনদারগন আরও সম্মত হলেন যে, মালিক প্রথমেই নিশ্চয়তা প্রদানকারীদের বিরুদ্ধে একক বা যৌথভাবে আইনগত
                ব্যবস্থা গ্রহণ করিতে পারিবেন।
              </li>
            </ul>
            <ul>
              <li>b.</li>
              <li>That they hereby renounce that the rights to claim the hirer's property should be discussed into the
                first instance and any other benefits to which sureties are by law entitled.
              </li>
            </ul>
            <ul>
              <li>c.</li>
              <li>That the neglect or forborne of the owner in enforcing payment of any money due under this agreement
                or
                any other indulgence shown to the Hirer shall not release hirer or the guarantors from their several
                obligations under this agreement or in any way after the obligation of the hirer and/or guarantors
                hereunder and shall not in any way affect the rights to the owner in hereunder.
              </li>
            </ul>
            <ul>
              <li>গ.</li>
              <li>অত্র চুক্তি অনুযায়ী প্রাপ্য কোন অর্থ আদায়ের ক্ষেত্রে মালিকের কোন অবহেলা বা বিরতি অথবা অন্য কোন
                আনুকুল্য
                ভাড়াগ্রহিতা বা জামিনদারদের অত্র চুক্তি অথবা অন্যকোনভাবে বিভিন্ন বাধ্যবাধকতা থেকে মুক্তি দিবে না এবং
                কোনভাবে মালিকের অধিকার ক্ষুন্ন করবে না।
              </li>
            </ul>
          </div>
          <div class="parent_dv">
            <ul>
              <li>13.</li>
              <li>Any notice shall be deemed to be duly given if sent by registered post/mobile/e-mail
                addressed in the
                case of the owner to its registered office in Dhaka aforesaid and in the case of the hirer or of either of
                the guarantors, addressed to their respective address aforesaid, or to any changed address if such has been
                noticed to the owner, and such notice shall be deemed to have been served and to take effect on the next day
                following the date of posting thereof.</li>
            </ul>
          <ul>
            <li>১৩.</li>
            <li> কোন প্রকার নোটিশ বা বিজ্ঞপ্তি যথাযথ ভাবে প্রদান করা হয়েছে বলে গণ্য হইবে যদি তাহা
              নিবন্ধিত ডাকযোগে/মোবাইলে/ইমেইলের মাধ্যেমে মালিক, ভাড়াগ্রহিতা বা জামিনদারের উপরোল্লিখিত ঠিকানায় অথবা সময়ে
              সময়ে পরিবর্তিত অন্য কোন ঠিকানায় [যা মালিককে অবগত করা হয়েছে] প্রেরিত হয় এবং তাহা যেদিন পোস্ট করা হইবে তার
              পরেরদিন থেকে কার্যকর হইবে।</li>
          </ul>
          <ul>
            <li>14.</li>
            <li>In case of interpretation of this agreement English shall prevail over Bangla meaning. </li>
          </ul>
          <ul>
            <li>১৪.</li>
            <li>অত্র চুক্তি ব্যাখ্যার ক্ষেত্রে ইংরেজি অর্থ বাংলা অর্থের উপর প্রাধান্য পাইবে। </li>
          </ul>

          </div>
          <h5>Important</h5>
          <p>The agreement has been read by/to me in my own language and I hereby declare that I have understood the
            contents of this document.</p>
          <br>
          <h5>জরুরী</h5>
          <p>এই চুক্তিনামা আমার নিজের ভাষায় আমাদ্ব্ারা পাঠিত/আমাকে পাঠ করিয়া শুনানো হইয়াছে এবং আমি ঘোষণা করিতেছি যে আমি
            এই দলিলের বিষয়বস্তু বুঝিতে পারিয়াছি।</p>
          <br>
          <!-- <table class="agreement-table">
            <thead>
            <tr>
              <th></th>
              <th><h5>Butterfly Marketing Limited.</h5></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <li>Witness...................</li>
                <li>Address....................</li>
                <li>Witness...................</li>
                <li>Address....................</li>
                <li>Witness...................</li>
                <li>Address....................</li>
              </td>
              <td>
                <li style="text-align: right">By......................................</li>
                <li>Hirer<span class="sp-val">{{userEkyc.parsonal.name}}</span></li>
                <li>Guarantor<span class="sp-val">{{guarantorOne}}</span></li>
                <li>Guarantor<span class="sp-val">{{guarantorTwo}}</span></li>
              </td>
            </tr>
            </tbody>
          </table> -->
        </div>
        <p></p>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
  import moment from 'moment'
  import gql from 'graphql-tag'
  export default {
      data () {
        return {
          userEkyc:{
            parsonal:{
              name:'',
              last_name:'',
            },
            contact:{
              presentAddress:{},
              permanentAddress:{}
            },
          },
          purchase:'',
          productMaster:'',
          guarantorOne:'',
          guarantorTwo:'',
          acceptedDt:'',
          year:'',
          month:'',
          day:''
        }
      },
      apollo: {
      purchase: {
        query: gql`
        query purchase($id: ID) {
          purchase(id: $id) {
            id
            used_location
            location
            brand
            price_range
            serial_number
            status,
            updated_at
            guarantors {
              id
              name
              phone
              email
              relationship
              status
              ekyc {
                id
                phone
                nid
                email
                status
                parsonal {
                  id
                  name
                  last_name
                  father_name
                  mother_name
                  spouse_name
                  age
                  marital_status
                  gender
                  head_of_household
                  education_level
                  nid
                }
                contact {
                  id
                  mobile
                  other_phone
                  email
                  presentAddress {
                    id
                    division
                    district
                    thana
                    address
                    near_landmark
                    postal_code
                    house_hold_type
                    living_in_this_address
                  }
                  permanentAddress {
                    id
                    pdivision
                    pdistrict
                    pthana
                    paddress
                    pnear_landmark
                    ppostal_code
                    phouse_hold_type
                    pliving_in_this_address
                  }
                }
                occupation {
                  id
                  occupation_type
                  occupation
                  monthly_income
                  name_of_Office_or_business
                  designation
                  job_length
                  occupationAddress {
                    id
                    division
                    district
                    thana
                    office_area
                    address
                    postal_code
                  }
                }
                dependent {
                  id
                  number_of_child
                  number_of_dependent
                  depandantDetails {
                    id
                    relation
                    name
                    age
                  }
                }
              }
            }
            product {
              id
              product
              status
            }
            user {
              id
              name
              phone
              email
              ekyc {
                id
                phone
                nid
                email
                status
                parsonal {
                  id
                  name
                  last_name
                  father_name
                  mother_name
                  spouse_name
                  age
                  marital_status
                  gender
                  head_of_household
                  education_level
                  nid
                }
                contact {
                  id
                  mobile
                  other_phone
                  email
                  presentAddress {
                    id
                    division
                    district
                    thana
                    address
                    near_landmark
                    postal_code
                    house_hold_type
                    living_in_this_address
                  }
                  permanentAddress {
                    id
                    pdivision
                    pdistrict
                    pthana
                    paddress
                    pnear_landmark
                    ppostal_code
                    phouse_hold_type
                    pliving_in_this_address
                  }
                }
                occupation {
                  id
                  occupation_type
                  occupation
                  monthly_income
                  name_of_Office_or_business
                  designation
                  job_length
                  occupationAddress {
                    id
                    division
                    district
                    thana
                    office_area
                    address
                    postal_code
                  }
                }
                dependent {
                  id
                  number_of_child
                  number_of_dependent
                  depandantDetails {
                    id
                    relation
                    name
                    age
                  }
                }
              }
            }
            productMaster{
              id
              article
              article_description
              profit_center
              profit_center_description
              mdse_cat
              merchandise_category
              hire_price
              down_payment
              monthly_inst
              pricing_date
            }
            notifications{
              id
              description
            }
          }
        }
      `,
        variables () {
          return {
            id: this.$route.params.applicationId
          }
        },
        update: (data) => data.purchase
      },
    },
    watch: {
      purchase (value) {
        this.purchase = value;
        this.userEkyc = value.user.ekyc;
        this.productMaster = value.productMaster;
        this.acceptedDt = moment(this.purchase.updated_at).format("yyyy-MM-DD")
        var dateArr = this.acceptedDt.split('-');
        this.day = dateArr[2]
        this.month = dateArr[1]
        this.year = dateArr[0]
        this.guarantorOne = value.guarantors[0];
        this.guarantorTwo = value.guarantors[1];

      }
    },
    methods:{
      gotoDashboard(){
        this.$router.push('/showroomDashboard').catch(() => { })
      },
      convertToWord(num){
        var a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
        var b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];


        if ((num = num.toString()).length > 9) return 'overflow';
        let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return; var str = '';
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
        str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
        return str;
      }
    }
    }
</script>

<style scoped>
  .receipt img{
    width: 100%;
  }
  .agreement-body {
    text-align: justify;
    font-size: 16px;
    line-height: 40px;
  }

  .agreement-body h4 {
    text-align: center;
    padding: 15px 0px;
  }
  .agreement-body h5 {
    padding: 10px 0px;
  }
  span.sp-val {
    border-bottom: 2px dotted #908c8c;
    padding: 0px 15px;
}

  .parent_dv ul li {
    display: table-cell;
    padding-bottom: 25px;
  }

  .parent_dv ul li:last-child {
    padding-left: 15px;
  }

  .child_dv ul {
    padding-left: 40px;
  }

  .child_dv ul li {
    display: table-cell;
    padding-bottom: 25px;
  }

  .child_dv ul li:last-child {
    padding-left: 15px;
  }
  .agreement-table tbody li {
    list-style: none;
    padding: 5px 10px;
  }
  .agreement-table {
    width: 100%;
    border: 1px solid #ddd;
    border-collapse: collapse;
  }
  .agreement-table  td, th {
    border: 2px solid #797979;
  }
  @media print {
    .vx-navbar-wrapper.nav-menu-wrapper {
      display: none;
    }
    .cursor-pointer.navbar-fuzzy-search.ml-4.feather-icon.select-none.relative {
      display: none;
    }
    .vs-con-dropdown.parent-dropdown.cursor-pointer {
      display: none;
    }
    .vue-back-to-top {
      display: none;
    }
    .the-footer.flex-wrap.justify-between {
      display: none;
    }
    .okBtn{
      display: none;
    }
  }
</style>
